import { useState } from 'react';
import { Title, Flex } from '@mantine/core';

import { useGetPaymentsStats } from '@/modules/payments';
import {
  Stats,
  StatsFilter,
  StatsPeriod,
  Statistics,
  getStatsPeriodParams,
  useGetStatistics,
} from '@/modules/stats';

import type { TGetPaymentsStatsParams } from '@/modules/payments/store/types';
import type { TStatsPeriod } from '@/modules/stats/store/types';

const initialPeriod: TStatsPeriod = 'today';

export const Home = () => {
  const [period, setPeriod] = useState<TStatsPeriod | null>(initialPeriod);

  const {
    data,
    isLoading,
    handleFilterChange: handlePaymentsStatsFilterChange,
  } = useGetPaymentsStats(getStatsPeriodParams(initialPeriod));

  const {
    items: statistics,
    isLoading: isStatisticsLoading,
    handleFilterChange: handleStatisticsFilterChange,
  } = useGetStatistics(getStatsPeriodParams(initialPeriod));

  const handleFilterChange = (data: TGetPaymentsStatsParams) => {
    handlePaymentsStatsFilterChange(data);
    handleStatisticsFilterChange({
      createdFrom: data.createdFrom,
      createdTo: data.createdTo,
      shopId: data.shopId,
    });
  };

  const handlePeriodChange = (value: TStatsPeriod) => {
    setPeriod(value);
    handleFilterChange(getStatsPeriodParams(value));
  };

  const handleFilterSubmit = (data: TGetPaymentsStatsParams) => {
    setPeriod(null);
    handleFilterChange(data);
  };

  const handleFilterReset = () => {
    setPeriod(initialPeriod);
    handleFilterChange(getStatsPeriodParams(initialPeriod));
  };

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Главная</Title>
      </Flex>

      <StatsPeriod
        value={period}
        onChange={handlePeriodChange}
      />

      <StatsFilter
        onSubmit={handleFilterSubmit}
        onReset={handleFilterReset}
      />

      <Stats
        data={data}
        isLoading={isLoading}
      />

      <Statistics
        items={statistics}
        isLoading={isStatisticsLoading}
      />
    </>
  );
};
